import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const NewFlight = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="28"
        height="26"
        viewBox="0 0 28 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 1V13"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M20 7H8"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M1 18V22C1 23.657 2.343 25 4 25H24C25.657 25 27 23.657 27 22V18"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </svg>
    </SvgIcon>
  )
}

export default NewFlight
